module.exports = __webpack_public_path__ + "static/media/yellowCheck.43479077.svg";